import React from "react";

const NavBar = () => {
    return (
        <nav className="flex items-center justify-center h-16 bg-blue-500 text-white">
            <a href="/" className="text-xl font-bold">
                GPT Botspotting
            </a>
        </nav>
    );
};

export default NavBar;
